import React, { useState } from 'react';
import { MapPinIcon, ArrowLeftIcon, MapIcon, PlusIcon, XIcon, SearchIcon, InfoIcon } from 'lucide-react';
import { JobLocationsMap } from './JobLocationsMap';
import { JobLocationsTable } from './JobLocationsTable';
export const JobLocationsPage = ({
  onBack
}) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [showGeoPunchSettings, setShowGeoPunchSettings] = useState(false);
  const [geoPunchDistance, setGeoPunchDistance] = useState(100); // Default to 100 feet
  const [jobLocations, setJobLocations] = useState([{
    id: '1',
    name: 'Downtown SLC Project',
    jobNumber: 'JOB-2023-001',
    usageType: 'load-dump',
    address: '123 Main St, Salt Lake City, UT 84101',
    foreman: 'John Smith',
    lat: 40.7608,
    lng: -111.891
  }, {
    id: '2',
    name: 'Sugar House Development',
    jobNumber: 'JOB-2023-002',
    usageType: 'load',
    address: '2100 S 1100 E, Salt Lake City, UT 84106',
    foreman: 'Mike Johnson',
    lat: 40.7247,
    lng: -111.8638
  }, {
    id: '3',
    name: 'West Valley Materials Yard',
    jobNumber: 'JOB-2023-003',
    usageType: 'dump',
    address: '3500 W 4500 S, West Valley City, UT 84119',
    foreman: 'Sarah Williams',
    lat: 40.6723,
    lng: -112.0103
  }]);
  const handleAddLocation = newLocation => {
    setJobLocations([...jobLocations, {
      id: `${jobLocations.length + 1}`,
      ...newLocation,
      lat: 40.7608,
      lng: -111.891
    }]);
    setShowAddForm(false);
  };
  const handleSaveGeoPunchSettings = () => {
    // In a real application, this would save to a database or API
    console.log(`Geo punch distance set to ${geoPunchDistance} feet`);
    setShowGeoPunchSettings(false);
  };
  return <div className="p-6 w-full" data-id="element-123">
      <div className="flex justify-between items-center mb-6" data-id="element-124">
        <div className="w-1/3" data-id="element-125">
          <button className="flex items-center gap-2 text-[#0F2A52] hover:text-[#0F2A52]/80 transition-colors" onClick={onBack} data-id="element-126">
            <ArrowLeftIcon size={18} data-id="element-127" />
            <span data-id="element-128">Back</span>
          </button>
        </div>
        <h1 className="text-2xl font-bold text-center w-1/3 text-[#0F2A52]" data-id="element-129">
          Manage Job/Locations
        </h1>
        <div className="flex justify-end w-1/3" data-id="element-130">
          <button className="bg-[#0F2A52] hover:bg-[#0F2A52]/90 text-white px-4 py-2 rounded-md flex items-center gap-2 transition-colors" onClick={() => setShowGeoPunchSettings(true)} data-id="element-131">
            <MapPinIcon size={18} data-id="element-132" />
            Geo Punch Settings
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4" data-id="element-133">
        <div className="bg-white rounded-md shadow overflow-hidden" data-id="element-134">
          <div className="p-4 bg-gray-50 border-b flex items-center gap-2" data-id="element-135">
            <MapPinIcon size={18} className="text-[#0F2A52]" data-id="element-136" />
            <h2 className="font-medium text-[#0F2A52]" data-id="element-137">Job Locations</h2>
          </div>
          {showAddForm ? <AddLocationForm onSave={handleAddLocation} onCancel={() => setShowAddForm(false)} data-id="element-138" /> : <div className="p-4" data-id="element-139">
              <button onClick={() => setShowAddForm(true)} className="w-full py-2 bg-[#F58220] hover:bg-[#F58220]/90 text-white rounded flex items-center justify-center gap-2 transition-colors" data-id="element-140">
                <PlusIcon size={18} data-id="element-141" />
                Add New Job Location
              </button>
            </div>}
        </div>
        <div className="lg:col-span-2 bg-white rounded-md shadow overflow-hidden" data-id="element-142">
          <div className="p-4 bg-gray-50 border-b flex items-center gap-2" data-id="element-143">
            <MapIcon size={18} className="text-[#0F2A52]" data-id="element-144" />
            <h2 className="font-medium text-[#0F2A52]" data-id="element-145">Job Locations Map</h2>
          </div>
          <div className="h-[300px] bg-gray-100" data-id="element-146">
            <JobLocationsMap locations={jobLocations} data-id="element-147" />
          </div>
        </div>
      </div>
      <div className="bg-white rounded-md shadow overflow-hidden mb-4" data-id="element-148">
        <div className="p-4 bg-gray-50 border-b" data-id="element-149">
          <h2 className="font-medium text-[#0F2A52]" data-id="element-150">Map Legend</h2>
        </div>
        <div className="p-4 grid grid-cols-2 gap-4" data-id="element-151">
          <div className="flex items-center gap-2" data-id="element-152">
            <span className="h-3 w-3 rounded-full bg-yellow-500" data-id="element-153"></span>
            <span data-id="element-154">Load & Dump Site</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-155">
            <span className="h-3 w-3 rounded-full bg-[#0F2A52]" data-id="element-156"></span>
            <span data-id="element-157">Load Site Only</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-158">
            <span className="h-3 w-3 rounded-full bg-[#F58220]" data-id="element-159"></span>
            <span data-id="element-160">Dump Site Only</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-161">
            <span className="h-3 w-3 rounded-full bg-green-500" data-id="element-162"></span>
            <span data-id="element-163">New/Editing Location (unsaved)</span>
          </div>
          <div className="col-span-2 flex items-center gap-2 text-gray-600 text-sm" data-id="element-164">
            <InfoIcon size={16} className="text-[#0F2A52]" data-id="element-165" />
            <span data-id="element-166">
              Click on a location marker to select it, or click on the map to
              set a location when adding/editing
            </span>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-md shadow overflow-hidden" data-id="element-167">
        <div className="p-4 bg-gray-50 border-b flex items-center gap-2" data-id="element-168">
          <MapPinIcon size={18} className="text-[#0F2A52]" data-id="element-169" />
          <h2 className="font-medium text-[#0F2A52]" data-id="element-170">All Job Locations</h2>
        </div>
        <JobLocationsTable locations={jobLocations} data-id="element-171" />
      </div>
      {/* Geo Punch Settings Modal */}
      {showGeoPunchSettings && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-172">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md" data-id="element-173">
            <div className="flex items-center justify-between p-4 border-b" data-id="element-174">
              <h3 className="font-medium flex items-center gap-2 text-[#0F2A52]" data-id="element-175">
                <MapPinIcon size={18} className="text-[#F58220]" data-id="element-176" />
                Geo Punch Settings
              </h3>
              <button onClick={() => setShowGeoPunchSettings(false)} className="text-gray-500 hover:text-gray-700" data-id="element-177">
                <XIcon size={18} data-id="element-178" />
              </button>
            </div>
            <div className="p-6" data-id="element-179">
              <p className="text-gray-600 mb-4" data-id="element-180">
                Set the maximum distance that drivers can clock in from a job
                location pin. This setting applies to all job locations.
              </p>
              <div className="space-y-3 mb-6" data-id="element-181">
                <label className="flex items-center p-3 border rounded hover:bg-gray-50 cursor-pointer" data-id="element-182">
                  <input type="radio" name="geoPunchDistance" checked={geoPunchDistance === 50} onChange={() => setGeoPunchDistance(50)} className="mr-3 text-[#0F2A52]" data-id="element-183" />
                  <div data-id="element-184">
                    <div className="font-medium" data-id="element-185">50 feet</div>
                    <div className="text-sm text-gray-500" data-id="element-186">
                      Strict - Requires drivers to be very close to the pin
                    </div>
                  </div>
                </label>
                <label className="flex items-center p-3 border rounded hover:bg-gray-50 cursor-pointer" data-id="element-187">
                  <input type="radio" name="geoPunchDistance" checked={geoPunchDistance === 100} onChange={() => setGeoPunchDistance(100)} className="mr-3 text-[#0F2A52]" data-id="element-188" />
                  <div data-id="element-189">
                    <div className="font-medium" data-id="element-190">100 feet</div>
                    <div className="text-sm text-gray-500" data-id="element-191">
                      Moderate - Recommended for most job sites
                    </div>
                  </div>
                </label>
                <label className="flex items-center p-3 border rounded hover:bg-gray-50 cursor-pointer" data-id="element-192">
                  <input type="radio" name="geoPunchDistance" checked={geoPunchDistance === 250} onChange={() => setGeoPunchDistance(250)} className="mr-3 text-[#0F2A52]" data-id="element-193" />
                  <div data-id="element-194">
                    <div className="font-medium" data-id="element-195">250 feet</div>
                    <div className="text-sm text-gray-500" data-id="element-196">
                      Lenient - For large job sites or areas with poor GPS
                      signal
                    </div>
                  </div>
                </label>
              </div>
              <div className="flex justify-end gap-3" data-id="element-197">
                <button onClick={() => setShowGeoPunchSettings(false)} className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-50" data-id="element-198">
                  Cancel
                </button>
                <button onClick={handleSaveGeoPunchSettings} className="px-4 py-2 bg-[#F58220] hover:bg-[#F58220]/90 text-white rounded transition-colors" data-id="element-199">
                  Save Settings
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
const AddLocationForm = ({
  onSave,
  onCancel
}) => {
  const [formData, setFormData] = useState({
    name: '',
    jobNumber: '',
    usageType: 'load-dump',
    address: '',
    foreman: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleRadioChange = value => {
    setFormData({
      ...formData,
      usageType: value
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };
  return <form onSubmit={handleSubmit} className="p-4" data-id="element-200">
      <div className="flex justify-between items-center mb-4" data-id="element-201">
        <h3 className="font-medium text-[#0F2A52]" data-id="element-202">Add New Job Location</h3>
        <button type="button" onClick={onCancel} className="text-gray-500 hover:text-gray-700" data-id="element-203">
          <XIcon size={18} data-id="element-204" />
        </button>
      </div>
      <div className="mb-3" data-id="element-205">
        <label className="block text-sm mb-1" data-id="element-206">Job Name</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Enter job name" className="w-full border rounded p-2 text-sm focus:border-[#0F2A52] focus:ring-1 focus:ring-[#0F2A52] outline-none" required data-id="element-207" />
      </div>
      <div className="mb-3" data-id="element-208">
        <label className="block text-sm mb-1" data-id="element-209">Job Number</label>
        <input type="text" name="jobNumber" value={formData.jobNumber} onChange={handleChange} placeholder="e.g. JOB-2023-001" className="w-full border rounded p-2 text-sm focus:border-[#0F2A52] focus:ring-1 focus:ring-[#0F2A52] outline-none" required data-id="element-210" />
      </div>
      <div className="mb-3" data-id="element-211">
        <label className="block text-sm mb-1" data-id="element-212">Usage Type</label>
        <div className="space-y-1" data-id="element-213">
          <label className="flex items-center" data-id="element-214">
            <input type="radio" checked={formData.usageType === 'load-dump'} onChange={() => handleRadioChange('load-dump')} className="mr-2 text-[#0F2A52]" data-id="element-215" />
            <span className="text-sm" data-id="element-216">Both (Load & Dump)</span>
          </label>
          <label className="flex items-center" data-id="element-217">
            <input type="radio" checked={formData.usageType === 'load'} onChange={() => handleRadioChange('load')} className="mr-2 text-[#0F2A52]" data-id="element-218" />
            <span className="text-sm" data-id="element-219">Load Site Only</span>
          </label>
          <label className="flex items-center" data-id="element-220">
            <input type="radio" checked={formData.usageType === 'dump'} onChange={() => handleRadioChange('dump')} className="mr-2 text-[#0F2A52]" data-id="element-221" />
            <span className="text-sm" data-id="element-222">Dump Site Only</span>
          </label>
        </div>
      </div>
      <div className="mb-3" data-id="element-223">
        <label className="block text-sm mb-1" data-id="element-224">Location Address</label>
        <div className="relative" data-id="element-225">
          <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="Enter address or click on map" className="w-full border rounded p-2 pr-8 text-sm focus:border-[#0F2A52] focus:ring-1 focus:ring-[#0F2A52] outline-none" required data-id="element-226" />
          <SearchIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-227" />
        </div>
        <p className="text-xs text-gray-500 mt-1" data-id="element-228">
          Enter an address, search, or click on the map
        </p>
      </div>
      <div className="mb-4" data-id="element-229">
        <label className="block text-sm mb-1" data-id="element-230">Assign Foreman</label>
        <select name="foreman" value={formData.foreman} onChange={handleChange} className="w-full border rounded p-2 text-sm appearance-none bg-white focus:border-[#0F2A52] focus:ring-1 focus:ring-[#0F2A52] outline-none" required data-id="element-231">
          <option value="" data-id="element-232">Select foreman...</option>
          <option value="John Smith" data-id="element-233">John Smith</option>
          <option value="Mike Johnson" data-id="element-234">Mike Johnson</option>
          <option value="Sarah Williams" data-id="element-235">Sarah Williams</option>
        </select>
      </div>
      <button type="submit" className="w-full bg-[#0F2A52] hover:bg-[#0F2A52]/90 text-white py-2 rounded flex items-center justify-center gap-2 transition-colors" data-id="element-236">
        <PlusIcon size={18} data-id="element-237" />
        Save New Job Location
      </button>
    </form>;
};